 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLHALFTITLE from '@/components/xhtml/halftitle'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import XHTMLDEDICATION from '@/components/xhtml/dedication'
 import XHTMLCONTENTS from '@/components/xhtml/contents'
 import XHTMLACKNOWLEDGMENTS from '@/components/xhtml/acknowledgments'
 import XHTMLNAMES_AND_RELATIONSHIPS from '@/components/xhtml/names_and_relationships'
 import XHTMLHALFTITLE1 from '@/components/xhtml/halftitle1'
 import XHTMLPROLOGUE from '@/components/xhtml/prologue'
 import XHTMLCHAPTER_001 from '@/components/xhtml/chapter_001'
 import XHTMLCHAPTER_002 from '@/components/xhtml/chapter_002'
 import XHTMLCHAPTER_003 from '@/components/xhtml/chapter_003'
 import XHTMLCHAPTER_004 from '@/components/xhtml/chapter_004'
 import XHTMLCHAPTER_005 from '@/components/xhtml/chapter_005'
 import XHTMLCHAPTER_006 from '@/components/xhtml/chapter_006'
 import XHTMLCHAPTER_007 from '@/components/xhtml/chapter_007'
 import XHTMLEPILOGUE from '@/components/xhtml/epilogue'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLGLOSSARY from '@/components/xhtml/glossary'
 import XHTMLNOTES from '@/components/xhtml/notes'
 import XHTMLREFERENCES from '@/components/xhtml/references'
 import XHTMLINDEX from '@/components/xhtml/index'
 import XHTMLABOUT_THE_AUTHOR from '@/components/xhtml/about_the_author'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/contents",
 			"name" : "xhtml/contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/acknowledgments",
 			"name" : "xhtml/acknowledgments",
 			"component" : XHTMLACKNOWLEDGMENTS
 		},
 		{
 			"path" : "/xhtml/names_and_relationships",
 			"name" : "xhtml/names_and_relationships",
 			"component" : XHTMLNAMES_AND_RELATIONSHIPS
 		},
 		{
 			"path" : "/xhtml/halftitle1",
 			"name" : "xhtml/halftitle1",
 			"component" : XHTMLHALFTITLE1
 		},
 		{
 			"path" : "/xhtml/prologue",
 			"name" : "xhtml/prologue",
 			"component" : XHTMLPROLOGUE
 		},
 		{
 			"path" : "/xhtml/chapter_001",
 			"name" : "xhtml/chapter_001",
 			"component" : XHTMLCHAPTER_001
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js